// extracted by mini-css-extract-plugin
export default {"forecast-container":"forecast-wrapper_forecast-container__HABl3"};